import * as React from 'react';
import { joinClassNames } from '@/lib/class-names';
import s from './SidebarButton.module.scss';

type SidebarButtonSize = 'md' | 'sm';

export interface SidebarButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  leading?: React.ReactNode;
  endAdornment?: React.ReactNode;
  count?: React.ReactNode;
  size?: SidebarButtonSize;
}

export function SidebarButton({
  active = false,
  leading,
  endAdornment,
  count,
  size = 'md',
  className,
  children,
  type = 'button',
  ...rest
}: SidebarButtonProps) {
  return (
    <button
      type={type}
      className={joinClassNames(
        s.button,
        size === 'sm' ? s.buttonSm : s.buttonMd,
        active && s.buttonActive,
        className,
      )}
      {...rest}
    >
      {leading ? <span className={s.leading}>{leading}</span> : null}
      <span className={s.label}>{children}</span>
      {endAdornment ? (
        <span className={s.end}>{endAdornment}</span>
      ) : count != null ? (
        <span className={joinClassNames(s.end, s.count)}>{count}</span>
      ) : null}
    </button>
  );
}
